import { useState } from 'react'
import { Button, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { CurrencyUtils } from '../../common/CurrencyUtils';
import Feedback from 'react-bootstrap/esm/Feedback';
import { SkuParamListener } from '../../domain/models/SkuDetail';
import { AnimationTypeValues, getAnimationClass } from '../../presentation/constants/AnimationType';
import { SkuButtonFlowListener } from './SkuDetailFlowButtons';
import { RequestParam } from '../../domain/models/RequestParam';
import { applog } from '../../domain/utils/applog';


export const SkuInputAmount = ({
    nameParam,
    minAmount,
    maxAmount,
    skuParamListener,
    buttonFlowListener,
    animationType,
    initialAmount,
    disabled

}: any) => {

    const [state, setState] = useState({
        amount: initialAmount,
        isValid: initialAmount !== undefined,
        feedback: ""
    })

    function handleChange(value: string) {
        const amount = parseFloat(value);
        let isValid = true;
        let feedback = "";
        if (amount) {
            if (maxAmount && amount > maxAmount) {
                isValid = false;
                feedback = `Has excedido el monto máximo ( ${CurrencyUtils.moneyFormat(maxAmount)} )`;
            }
            if (minAmount && amount < minAmount) {
                isValid = false
                feedback = `El monto mínimo es de ${CurrencyUtils.moneyFormat(minAmount)}`
            }
        } else {
            isValid = false;
            feedback = "Campo obligatorio"
        }
        setState((s: any) => {
            return {
                ...s,
                amount: value,
                isValid: isValid,
                feedback: feedback
            }
        })
    }

    function handleContinue(e: any) {
        e.preventDefault();
        applog("SkuInputAmount", "handleContinue()");
        if (state.isValid && state.amount) {
            buttonFlowListener?.onContinuePressed(new RequestParam(nameParam, `${state.amount}`, 'Monto'));
        }
    }

    return (
        <div className={getAnimationClass(animationType)}>
            <Form onSubmit={handleContinue}>
                <Form.Group className={"m-4"}>
                    <Form.Label>Monto</Form.Label>
                    <Form.Control
                        disabled={disabled ?? false}
                        name={nameParam}
                        as="input"
                        type="number"
                        value={state.amount}
                        isInvalid={!state.isValid}
                        onChange={(e) => { handleChange(e.target.value) }}></Form.Control>
                    <Feedback type="invalid" >
                        {state.feedback}
                    </Feedback>
                </Form.Group>
                {
                    buttonFlowListener?.onBackPressed &&
                    <Button variant="link" className="float-left ml-4  mt-4"
                        onClick={(e: any) => {
                            e.preventDefault();
                            buttonFlowListener.onBackPressed();
                        }}> Regresar </Button>

                }
                {
                    buttonFlowListener?.onContinuePressed &&
                    <Button
                        disabled={!state.isValid}
                        variant="primary" className="float-right mr-4  mt-4"
                        type="submit"> Continuar </Button>
                }

            </Form>

        </div>
    )
}

SkuInputAmount.propTypes = {
    nameParam: PropTypes.string.isRequired,
    minAmount: PropTypes.number,
    maxAmount: PropTypes.number,
    onBackPressed: PropTypes.func,
    skuParamListener: PropTypes.instanceOf(SkuParamListener),
    buttonFlowListener: PropTypes.instanceOf(SkuButtonFlowListener),
    animationType: PropTypes.oneOf(AnimationTypeValues),
    initialAmount: PropTypes.any,
    disabled: PropTypes.bool
}

